"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _core = require("@uppy/core");

// TODO: rename this file to StatusBar.jsx on the next major.
var getSpeed = require("@uppy/utils/lib/getSpeed");
var getBytesRemaining = require("@uppy/utils/lib/getBytesRemaining");
var getTextDirection = require("@uppy/utils/lib/getTextDirection");
var statusBarStates = require("./StatusBarStates.js");
var StatusBarUI = require("./StatusBar.js");
var packageJson = {
  "version": "2.2.2"
};
var locale = require("./locale.js");
function getTotalSpeed(files) {
  var totalSpeed = 0;
  files.forEach(function (file) {
    totalSpeed += getSpeed(file.progress);
  });
  return totalSpeed;
}
function getTotalETA(files) {
  var totalSpeed = getTotalSpeed(files);
  if (totalSpeed === 0) {
    return 0;
  }
  var totalBytesRemaining = files.reduce(function (total, file) {
    return total + getBytesRemaining(file.progress);
  }, 0);
  return Math.round(totalBytesRemaining / totalSpeed * 10) / 10;
}
function getUploadingState(error, isAllComplete, recoveredState, files) {
  if (error && !isAllComplete) {
    return statusBarStates.STATE_ERROR;
  }
  if (isAllComplete) {
    return statusBarStates.STATE_COMPLETE;
  }
  if (recoveredState) {
    return statusBarStates.STATE_WAITING;
  }
  var state = statusBarStates.STATE_WAITING;
  var fileIDs = Object.keys(files);
  for (var i = 0; i < fileIDs.length; i++) {
    var progress = files[fileIDs[i]].progress; // If ANY files are being uploaded right now, show the uploading state.

    if (progress.uploadStarted && !progress.uploadComplete) {
      return statusBarStates.STATE_UPLOADING;
    } // If files are being preprocessed AND postprocessed at this time, we show the
    // preprocess state. If any files are being uploaded we show uploading.

    if (progress.preprocess && state !== statusBarStates.STATE_UPLOADING) {
      state = statusBarStates.STATE_PREPROCESSING;
    } // If NO files are being preprocessed or uploaded right now, but some files are
    // being postprocessed, show the postprocess state.

    if (progress.postprocess && state !== statusBarStates.STATE_UPLOADING && state !== statusBarStates.STATE_PREPROCESSING) {
      state = statusBarStates.STATE_POSTPROCESSING;
    }
  }
  return state;
}
/**
 * StatusBar: renders a status bar with upload/pause/resume/cancel/retry buttons,
 * progress percentage and time remaining.
 */
var StatusBar = /*#__PURE__*/function (_core$UIPlugin) {
  _inherits(StatusBar, _core$UIPlugin);
  var _super = _createSuper(StatusBar);
  function StatusBar(uppy, opts) {
    var _this;
    _classCallCheck(this, StatusBar);
    _this = _super.call(this, uppy, opts);
    _this.startUpload = function () {
      var _this$uppy$getState = _this.uppy.getState(),
        recoveredState = _this$uppy$getState.recoveredState;
      if (recoveredState) {
        _this.uppy.emit('restore-confirmed');
        return undefined;
      }
      return _this.uppy.upload().catch(function () {// Error logged in Core
      });
    };
    _this.id = _this.opts.id || 'StatusBar';
    _this.title = 'StatusBar';
    _this.type = 'progressindicator';
    _this.defaultLocale = locale; // set default options

    var defaultOptions = {
      target: 'body',
      hideUploadButton: false,
      hideRetryButton: false,
      hidePauseResumeButton: false,
      hideCancelButton: false,
      showProgressDetails: false,
      hideAfterFinish: true,
      doneButtonHandler: null
    };
    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);
    _this.i18nInit();
    _this.render = _this.render.bind(_assertThisInitialized(_this));
    _this.install = _this.install.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(StatusBar, [{
    key: "render",
    value: function render(state) {
      var capabilities = state.capabilities,
        files = state.files,
        allowNewUpload = state.allowNewUpload,
        totalProgress = state.totalProgress,
        error = state.error,
        recoveredState = state.recoveredState;
      var _this$uppy$getObjectO = this.uppy.getObjectOfFilesPerState(),
        newFiles = _this$uppy$getObjectO.newFiles,
        startedFiles = _this$uppy$getObjectO.startedFiles,
        completeFiles = _this$uppy$getObjectO.completeFiles,
        inProgressNotPausedFiles = _this$uppy$getObjectO.inProgressNotPausedFiles,
        isUploadStarted = _this$uppy$getObjectO.isUploadStarted,
        isAllComplete = _this$uppy$getObjectO.isAllComplete,
        isAllErrored = _this$uppy$getObjectO.isAllErrored,
        isAllPaused = _this$uppy$getObjectO.isAllPaused,
        isUploadInProgress = _this$uppy$getObjectO.isUploadInProgress,
        isSomeGhost = _this$uppy$getObjectO.isSomeGhost; // If some state was recovered, we want to show Upload button/counter
      // for all the files, because in this case it’s not an Upload button,
      // but “Confirm Restore Button”

      var newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
      var totalETA = getTotalETA(inProgressNotPausedFiles);
      var resumableUploads = !!capabilities.resumableUploads;
      var supportsUploadProgress = capabilities.uploadProgress !== false;
      var totalSize = 0;
      var totalUploadedSize = 0;
      startedFiles.forEach(function (file) {
        totalSize += file.progress.bytesTotal || 0;
        totalUploadedSize += file.progress.bytesUploaded || 0;
      });
      return StatusBarUI({
        error: error,
        uploadState: getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
        allowNewUpload: allowNewUpload,
        totalProgress: totalProgress,
        totalSize: totalSize,
        totalUploadedSize: totalUploadedSize,
        isAllComplete: false,
        isAllPaused: isAllPaused,
        isAllErrored: isAllErrored,
        isUploadStarted: isUploadStarted,
        isUploadInProgress: isUploadInProgress,
        isSomeGhost: isSomeGhost,
        recoveredState: recoveredState,
        complete: completeFiles.length,
        newFiles: newFilesOrRecovered.length,
        numUploads: startedFiles.length,
        totalETA: totalETA,
        files: files,
        i18n: this.i18n,
        uppy: this.uppy,
        startUpload: this.startUpload,
        doneButtonHandler: this.opts.doneButtonHandler,
        resumableUploads: resumableUploads,
        supportsUploadProgress: supportsUploadProgress,
        showProgressDetails: this.opts.showProgressDetails,
        hideUploadButton: this.opts.hideUploadButton,
        hideRetryButton: this.opts.hideRetryButton,
        hidePauseResumeButton: this.opts.hidePauseResumeButton,
        hideCancelButton: this.opts.hideCancelButton,
        hideAfterFinish: this.opts.hideAfterFinish,
        isTargetDOMEl: this.isTargetDOMEl
      });
    }
  }, {
    key: "onMount",
    value: function onMount() {
      // Set the text direction if the page has not defined one.
      var element = this.el;
      var direction = getTextDirection(element);
      if (!direction) {
        element.dir = 'ltr';
      }
    }
  }, {
    key: "install",
    value: function install() {
      var target = this.opts.target;
      if (target) {
        this.mount(target, this);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.unmount();
    }
  }]);
  return StatusBar;
}(_core.UIPlugin);
StatusBar.VERSION = packageJson.version;
module.exports = StatusBar;